/*******************************************************************************
Trigger Closing A Modal Window
*******************************************************************************/

import closeModalWindow from './close';

export default function triggerCloseModalWindow(e) {

    // This variable determines whether the modal window should be closed
    let closeModal = false;

    // The element that the user clicked on
    const $clickTarget = $(e.target);

    // If the user clicked on an element that has one of these classes, then we should close the modal
    const targetsToClose = ['modal-background', 'close-modal'];

    // Check the click target against all the classes that should trigger the modal to close
    targetsToClose.forEach((className) => { if ($clickTarget.hasClass(className)) { closeModal = true; } });

    // Close the modal window if a class matched
    if (closeModal) { closeModalWindow(); }
}
